import React, { Component } from 'react';
import {connect} from "react-redux";
import SweetAlert from 'sweetalert-react';
import {showAlert} from "../../actions/AlertAction";
import 'sweetalert/dist/sweetalert.css';

class AlertRx extends Component {
    render() {
        return (
            <SweetAlert
                show={this.props.alert.show}
                title="Información"
                text={this.props.alert.message}
                type={this.props.alert.type}
                confirmButtonText="Aceptar"
                html={this.props.alert.html ? true:false}
                confirmButtonColor='#00D1C0'
                onConfirm={() => {
                    this.props.showAlert({ show: false });
                }}
            />
        );
    }
}

function mapStateToProps(state) {
    return {
        alert: state.get('alert'),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        showAlert(alert) {
            dispatch(showAlert(alert));
        }
    }
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(AlertRx);


// WEBPACK FOOTER //
// ./src/components/extras/AlertRx.js